define('app-ProductInfoBox/main',['./settings', './viewModel', '../app/ui/dialog'], function (settings, ViewModel, dialog) {
    return {
        run: function () {
            var $thisModule = this,
                container = $(settings.container);

            if (container.length === 0) {
                window.log('No ProductInfoBox found.  app-ProductInfoBox will not be available.');

                return;
            }

            container.find(settings.priceButton).on("click", function () {
                dialog.show('Finding available dates...', null, {
                    noClose: true,
                    modal: true,
                    draggable: false,
                    resizable: false
                });
            });

            container.find(settings.insuranceText).on("click", function (e) {
                e.preventDefault();

                var productContentHeader = $(".productContent h3").first();
                var moveUp = 10; // Default to 10px so there's a little extra room

                if ($(window).width() > 768) {
                    var headerHeight = $("#header").outerHeight();
                    var navHeight = $(".meganav").outerHeight();
                    var scrollHeight = headerHeight - navHeight;

                    moveUp += headerHeight - scrollHeight;
                }

                $("html, body").animate({ scrollTop: (productContentHeader.offset().top - moveUp) }, "slow", "swing");
            });

            /* Opening Times pop up*/
            $('.productInfoBox-opening, .productInfoBox #openingTimes').hover(function () {
                $('.productInfoBox #openingTimes').show();
            }, function () {
                $('.productInfoBox #openingTimes').hide();
            });

            /* Special offer overlay*/
            $('.specialOffers').on("click", function (e) {
                e.preventDefault();

                var contentDiv = $('<div/>');

                contentDiv.append($('.cruiseOfferPopUp').html());

                dialog.show('', contentDiv, {
                    modal: true,
                    draggable: false,
                    resizable: false
                });
                $('.modal-header').addClass('offer-modal p-0');
            });


            if ($('body').hasClass('cruise')) {
                //Add Datalayer values
                var frostedContainer = $('.ScrollContainer .adl-frostedContentsInner:visible');

                // departureDate
                var departureDate = localStorage.getItem('departureDate');
                if (departureDate) {
                    AdlAddUpdateItem('departureDate', departureDate);
                }
                var aaDateTxt = "";
                if ($('body').hasClass('oceanCruise')) {
                    var dateTxt = frostedContainer.find(".startDate").text().trim();
                    aaDateTxt = (dateTxt === undefined || dateTxt.length === 0) ? "any dates" : dateTxt;
                }
                else if ($('body').hasClass('riverCruise')) {
                    var dateTxt = $(".cruiseItinerary .dayDate:first").attr('data-adlstartdate');
                    aaDateTxt = (dateTxt == undefined || dateTxt.length === 0) ? "Multiple departures" : dateTxt;
                }
                AdlAddUpdateItem('departureDate', aaDateTxt);

                // Product Name
                var productName = $(".titleBanner_content h1").text().trim();
                var aaProductTxt = (productName === undefined || productName.length === 0) ? "" : productName;
                AdlAddUpdateItem('productName', aaProductTxt);

                //eg HB
                var boardBasis = frostedContainer.data("adlboardbasis").trim();
                var aaboardBasisTxt = (boardBasis === undefined || boardBasis.length === 0) ? "any board basis" : boardBasis;
                AdlAddUpdateItem('boardBasis', aaboardBasisTxt);

                //Ship
                var ship = $('[data-adlShip]').attr('data-adlShip');
                var aaShipTxt = (ship === undefined || ship.length === 0) ? "" : ship;
                AdlAddUpdateItem('ship', aaShipTxt);

                //Meta fb tag
                AdlAddUpdateItem('metaTravelStartDate', frostedContainer.data("adl-travel-start-date"));
                AdlAddUpdateItem('metaTravelEndDate', frostedContainer.data("adl-travel-end-date"));
                AdlAddUpdateItem('metaRegion', frostedContainer.data("adl-region"));
                AdlAddUpdateItem('metaCountry', frostedContainer.data("adl-country"));
                AdlAddUpdateItem('metaCity', frostedContainer.data("adl-city"));

                var productListFromLocalStoarage = localStorage.getItem("metaProductList"),
                    packageCode = document.querySelector("#frostedContentsInner").dataset["adlpackagecode"].toLowerCase(),
                    productList = document.referrer && document.referrer.indexOf("/search") > -1 && productListFromLocalStoarage && productListFromLocalStoarage.length > 0
                        ? productListFromLocalStoarage.split(',')
                        : document.querySelector("#frostedContentsInner").dataset["adlRelatedProducts"].split(',');

                AdlAddUpdateArrayItem('metaProductList', productList.filter(function (code) { return code.toLowerCase() !== packageCode }));

                window.loadedModules("app-ProductInfoBox");
            }
        }
    }
});
